import { NOTIFICATION_STATUS_CODE } from '../../enums/notification-status-code.enum';

export class NextNotificationStatus {
    public constructor(
        public statusCode: NOTIFICATION_STATUS_CODE,
        public enabled = true,
    ) {}
}
